import i18n from "i18next";
import I18NextXhrBackend from "i18next-xhr-backend";
import { initReactI18next } from "react-i18next";
// let en_json = require('./assets/translations/i18n/en.json');
import customData from './assets/translations/i18n/en.json';
import hiData from './assets/translations/i18n/hi.json';

// console.log(en_json);
let default_lang = localStorage.getItem('activeLanguage') ? localStorage.getItem('activeLanguage') : 'en';

i18n
    .use(I18NextXhrBackend)
    .use(initReactI18next)
    .init({
        fallbackLng: "en",
        lng: default_lang,
        interpolation: {
            escapeValue: false,
        },
        resources: {
            en: {
                translation: customData,
            },
            hi: {
                translation: hiData,
            },
        },
    });

export default i18n;